import { Box, Typography } from "@mui/material";
import Translate from "translate/Translate";
import { COLORS } from "components/v3/Theme/colors";
import GLButton from "components/v3/sharedComponents/GLButton";

type TestKitSelectionFooterBarProps = {
  onContinue?: () => void;
  onSubmit?: (uuids: string[]) => void;
  kitsToOfferMemberRightNow: any[];
  selectedKitUuids: string[];
  suggestedOffersUuids: string[];
};

const TestKitSelectionFooterBar = ({
  onContinue,
  onSubmit,
  kitsToOfferMemberRightNow = [],
  selectedKitUuids = [],
  suggestedOffersUuids = []
}: TestKitSelectionFooterBarProps) => {
  const numSuggestedOffers = kitsToOfferMemberRightNow?.length;
  const numSelectedOffers = selectedKitUuids?.length;
  const hasSuggestedOffer = numSuggestedOffers > 0;
  const hasSelectedOffer = numSelectedOffers > 0;
  const continueOrder = () => {
    const uuids = hasSelectedOffer ? selectedKitUuids : suggestedOffersUuids;

    if (uuids?.length === numSuggestedOffers) {
      onSubmit(uuids);
    } else {
      onContinue();
    }
  };

  if (!hasSuggestedOffer) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: "flex-start",
        backgroundColor: COLORS.PRIMARY_LIGHTEST,
        bottom: 0,
        boxSizing: "border-box",
        display: "flex",
        gap: "15px",
        justifyContent: "center",
        padding: {
          xs: "8px 16px",
          lg: 2
        },
        position: "fixed",
        width: "100%"
      }}
    >
      {hasSelectedOffer ? (
        <GLButton
          buttonType="primary"
          onClick={continueOrder}
          sx={{
            height: "auto !important",
            paddingX: 3,
            paddingY: 1
          }}
          title="Continue"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "4px"
            }}
          >
            <Typography variant="body_strong_xs_white">
              <Translate
                text={`${numSelectedOffers}/${numSuggestedOffers} tests requested`}
              />
            </Typography>
            <Typography variant="body_strong_lg_white">
              <Translate text="Continue" />
            </Typography>
          </Box>
        </GLButton>
      ) : (
        <Box
          component="button"
          onClick={continueOrder}
          sx={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            paddingX: 3,
            paddingY: 1
          }}
        >
          <Typography variant="body_strong_lg_primary">
            <Translate text="Request all suggested" />
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default TestKitSelectionFooterBar;
